// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content012_wrapper__EIlLf"};